import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "components/Layout";
import gutscheinImg from "assets/images/gutschein.png";
import "styles/empfehlungsprogramm.css";

const STEPS = [
  {
    title: "Link teilen",
    text: "In deinem Konto findest du deinen persönlichen Empfehlungslink. Teile ihn mit Freunden und Familie.",
  },
  {
    title: "Freund registriert sich",
    text: "Dein Freund meldet sich über deinen Link an. Die Empfehlung wird automatisch deinem Konto zugeordnet.",
  },
  {
    title: "5 € Guthaben erhalten",
    text: "Sobald dein Freund erstmals eine Massage bezahlt, erhaltet ihr beide einmalig 5 € Massageguthaben für eure nächste Buchung.",
  },
];

const RULES = [
  "Jeweils 5 € Guthaben für dich und den geworbenen Neukunden nach dessen erster bezahlter Massage",
  "Guthaben gilt nur für bezahlte Dr.-Hoffmann-Massagen auf dieser Website",
  "Beim Buchen wird vorhandenes Guthaben automatisch angerechnet – bis zur Höhe des Buchungspreises",
  "Bei Stornierung einer Buchung mit verwendetem Guthaben wird der Betrag wieder gutgeschrieben",
];

const EmpfehlungsprogrammPage = () => {
  const token = useSelector((state) => state.token);
  const ctaTo = token ? "/konto/empfehlen" : "/registrieren";
  const ctaLabel = token ? "Zum persönlichen Link" : "Kostenlos registrieren";

  return (
    <Layout bodyClass="referral-page-body">
      <section className="referral-hero">
        <div className="referral-hero__content">
          <div className="referral-shell">
            <span className="referral-kicker">Empfehlungsprogramm</span>
            <h1>
              Nie wieder für Massagen zahlen:{" "}
            </h1>
            <p className="referral-hero__subtitle">
              Teile deinen persönlichen Link und erhalte Guthaben für deine nächste Massage.
            </p>
            <p>
              Wenn sich jemand über deinen Link bei Dr. Hoffmann registriert und
              erstmals eine Massage bezahlt, erhaltet ihr beide einmalig 5&nbsp;€
              Massageguthaben für eure nächste Buchung auf dieser Website.
            </p>
            <Link className="btn-primary" to={ctaTo}>
              {ctaLabel}
            </Link>
          </div>
        </div>
        <div className="referral-hero__media">
          <img
            src={gutscheinImg}
            alt="Zwei Freundinnen teilen freudig einen Gutschein"
          />
        </div>
      </section>

      <section className="referral-section">
        <div className="referral-shell">
          <div className="referral-section__head">
            <span className="referral-kicker">So funktioniert’s</span>
            <h2>In drei Schritten zum Guthaben</h2>
          </div>
          <div className="referral-step-grid">
            {STEPS.map((step) => (
              <article className="referral-step" key={step.title}>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="referral-section referral-section--muted">
        <div className="referral-shell referral-intro">
          <span className="referral-kicker">Bedingungen</span>
          <h2>Das solltest du wissen</h2>
          <p>
            Das Empfehlungsprogramm gilt für Kundinnen und Kunden von
            Dr. Hoffmann Massage. Dein Guthaben kannst du bei der nächsten
            Massagebuchung einsetzen.
          </p>
          <ul className="referral-check-list">
            {RULES.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="referral-cta" id="starten">
        <div className="referral-shell referral-cta__inner">
          <div>
            <span className="referral-kicker">Loslegen</span>
            <h2>
              Starte jetzt dein{" "}
              <span className="referral-title-nowrap">Empfehlungsprogramm</span>
            </h2>
            <p>
              {token
                ? "Öffne dein Konto, kopiere deinen persönlichen Link und teile ihn mit Freunden."
                : "Registriere dich kostenlos – danach findest du deinen persönlichen Empfehlungslink in deinem Konto."}
            </p>
          </div>
          <div className="referral-cta__actions">
            <Link className="btn-primary" to={ctaTo}>
              {ctaLabel}
            </Link>
            {!token && (
              <Link className="btn-outline" to="/einloggen">
                Bereits registriert? Einloggen
              </Link>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default EmpfehlungsprogrammPage;
